module.exports = __webpack_public_path__ + "img/arquidry.22ec3b1e.png";